module.exports = __webpack_public_path__ + "static/media/ao.2c9a608f.svg";